import { gql } from '@apollo/client';

export const INVITE_MULTIPLE_USERS_MUTATION = gql`
  mutation InviteMultipleUsersMutation($input: UploadBulkUsersInput!) {
    inviteMultipleUsers(input: $input) {
      createdCount
      totalCount
      error
    }
  }
`;
